import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { setSelectedPhoneNumber, getPhoneNumbers } from '../../TransferOrganizationAccountSlice';
import SelectOptionButton from '../../../../Shared/SelectOptionButton/SelectOptionButton';

const SelectPhoneNumber = (props) => {
  const [numbersForSelect, setNumbersForSelect] = useState([]);

  useEffect(() => {
    if (props.data.phoneNumbersForSelect?.length > 0) {
      getNumberListForSelect();
    }
  }, [props.data.phoneNumbersForSelect]);

  function getNumberListForSelect() {
    const newNumbersForSelect = props.data.phoneNumbersForSelect.map((number, index) => {
      const selected = props.data.selectedPhoneNumber == number ? true : false;
      return { id: index, label: number, value: number, selected: selected };
    });
    setNumbersForSelect(newNumbersForSelect);
  }

  return (
    <div className='transfer-line-sub-step borderline'>
      {numbersForSelect.length > 0 && (
        <>
          <SelectOptionButton title={'מה יהיה המספר החדש?'} buttonsData={numbersForSelect} onClick={props.setSelectedPhoneNumber} />

          {props.data.phoneNumberRequest <= 4 && (
            <div className='select-phone-link'>
              <a className='link' onClick={() => props.getPhoneNumbers()}>
                אני רוצה לנסות מספרים נוספים
              </a>
            </div>
          )}
        </>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    data: state.TransferOrganizationAccount,
  };
};

const mapDispatchToProps = {
  setSelectedPhoneNumber,
  getPhoneNumbers,
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectPhoneNumber);
